module.exports = __webpack_public_path__ + "static/media/hall-P11.4283e62b.svg";